
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'feature-page',
    data() {
        return {

        }
    }
})
